module.exports = "<div v-bind:class=spinner v-show=loading transition=fade class=\"Spinner animated\"><div class=Spinner__icon></div><div name=spinner::text class=Spinner__text>loading...</div></div><slot v-if=!loading name=content></slot>";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-loader.js?raw&engine=jade!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/loaders/spinner.vue
// module id = 462
// module chunks = 0